import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Button, createStyles, Grid, makeStyles } from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { ApiResultModel } from "../../../models/common.model";
import { StoreResponse } from "../../models/store.model";
import { setCartCount } from "../../redux/cartSummary/cartCountAction";
import {
  DeleteCartItem,
  GetCartSummary,
  RegisterOrder,
} from "../../service/store.service";
import CancelModal from "../modals/cancelModal";
import ModalCmp from "../../../components/modals/ModalCmp";
import { styled } from "@material-ui/styles";
import { toast } from "react-toastify";

interface props {
  openOrder: any;
  setCount: any;
  count: any;
  inventoryId: any;
  orderId: any;
  setOrderId: any;
  setInventoryId: any;
  setNotEffectCount: any;
  setReloadOnRegister: any;
  setReloadOnDelete: any;
}

export default function ProductRegistration({
  openOrder,
  setCount,
  count,
  inventoryId,
  orderId,
  setOrderId,
  setInventoryId,
  setNotEffectCount,
  setReloadOnDelete,
  setReloadOnRegister,
}: props) {
  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openValidationModel, setOpenValidationModel] = useState<boolean>(
    false
  );
  const [validationMessages, setValidationMessages] = useState<string[]>([]);
  const { mutate: OrederRegisterMutate } = useMutation(RegisterOrder, {
    onSuccess: (data: ApiResultModel<StoreResponse>) => {
      setOpenValidationModel(false);
      if (data.isSuccess) {
        if (data.data.isValid) {
          setInventoryId(data.data.inventoryId);
          setOrderId(data.data.orderId);
          setReloadOnRegister(uuid());
          cartSummaryMutate.mutate();
          if (orderId > 0) {
            toast.success("سفارش با موفقیت در سبد خرید به روزرسانی شد");
          } else {
            toast.success("سفارش با موفقیت به سبد خرید اضافه شد");
          }
        } else {
          setOpenValidationModel(true);
          setValidationMessages(data.data.validationIssues!);
        }
      }
    },
  });
  const handleCount = (e: any, val: any) => {
    setCount(e.target.value);
    setNotEffectCount(false);
  };
  const handleOrederRegister = () => {
    if (orderId > 0) {
      OrederRegisterMutate({
        orderId,
        inventoryId,
        count,
      });
    } else {
      OrederRegisterMutate({
        inventoryId,
        count,
      });
    }
  };
  const handleDeleteRequest = () => {
    if (orderId > 0) {
      setOpenCancelModal(true);
    } else {
      setCount(0);
    }
  };

  const handleCancel = (e: any, l: any) => {
    setReloadOnDelete(uuid());
    cartSummaryMutate.mutate();
  };
  const dispatch = useDispatch();
  const cartSummaryMutate = useMutation(GetCartSummary, {
    onSuccess: (data) => {
      dispatch(setCartCount({ count: data.data }));
    },
  });
  const InputCSS = {};
  return (
    <Grid
      container
      spacing={2}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "5px",
        padding: "0 20px 20px 20px ",
        marginBottom: "5px",
      }}
      className="colorTitle "
    >
      <Grid
        item
        xs={12}
        style={{ borderBottom: "1px solid #E0E0E0" }}
        className="paddingGrid"
      >
        <b>
          {" "}
          <GppGoodOutlinedIcon /> &nbsp; {openOrder?.guarantyDescription}
        </b>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ borderBottom: "1px solid #E0E0E0" }}
        className="paddingGrid"
      >
        <span style={{ color: "#F06292", letterSpacing: "1px" }}>
          <img src="images/star.png" />
          &nbsp;
          <span className="fontMedium">مهلت خرید تا تاریخ</span>{" "}
          {openOrder?.expirationDate_Persian}
        </span>
      </Grid>
      <Grid item xs={12}>
        <span className="fontMedium" style={{ color: "#64B5F6" }}>
          {" "}
          <NotificationsNoneIcon /> &nbsp; تنها {openOrder?.availableCount} عدد
          در انبار باقیست{" "}
        </span>
      </Grid>
      <Grid
        item
        xs={12}
        container
        style={{ borderBottom: "1px solid #E0E0E0" }}
        className="paddingGrid"
      >
        <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
          <b>تعداد</b>
        </Grid>
        <Grid item xs={3}>
          <MaterialTextFieldComponent
            className={"shadowTextField"}
            error={openOrder?.insufficientInventory}
            // autoFocus={true}
            placeHolder={"*تعداد را وارد کنید "}
            required={true}
            type="number"
            value={count}
            onChange={(e: any, val: number) => handleCount(e, val)}
            name="count"
            id="count"
            inputProps={{
              min: 0,
              style: {},
            }}
            sx={{
              "&.MuiInputBase-root": {
                height: "20px !important",
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={7}
          className="colorTitle cursorPointer"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
          }}
        >
          <b onClick={handleDeleteRequest}>
            حذف درخواست <DeleteOutlineIcon />
          </b>
        </Grid>
        {openOrder
          ? openOrder?.insufficientInventory && (
              <Grid item xs={12} className="DangerDefaultFont">
                <InfoOutlinedIcon /> موجودی کافی نیست
              </Grid>
            )
          : ""}
        {}
      </Grid>
      <Grid
        item
        xs={12}
        container
        // spacing={2}
        style={{ borderBottom: "1px solid #E0E0E0" }}
        className="paddingGrid"
      >
        <Grid item xs={6}>
          <span className="fontMedium">قیمت پایه</span>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "left", color: "#424242" }}>
          <b>{openOrder?.basePrice.toLocaleString()} ریال</b>
        </Grid>
        <br />
        <br />
        <Grid item xs={6}>
          <span className="fontMedium">جمع کل</span>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "left", color: "#424242" }}>
          {/* <b>{openOrder?.totalAmount.toLocaleString()}</b> ریال */}
          {count > 0 ? <b>{openOrder?.totalAmount.toLocaleString()} </b> : 0}
          ریال
        </Grid>
        <br />
        <br />
        <Grid item xs={6} className="colorRed">
          <span className="fontMedium">تخفیف</span>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "left" }} className="colorRed">
          {/* <b>{openOrder?.discountAmount.toLocaleString()}</b> ریال */}
          {count > 0 ? <b>{openOrder?.discountAmount.toLocaleString()} </b> : 0}
          ریال
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <img src="images/dollar.png" />
        &nbsp; &nbsp; <span className="fontMedium">قابل پرداخت</span>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ textAlign: "left", fontSize: "1.5em" }}
        className="colorOk"
      >
        {/* <b>{openOrder?.finalAmount.toLocaleString()}</b> ریال */}
        {count > 0 ? <b>{openOrder?.finalAmount.toLocaleString()} </b> : 0}ریال
      </Grid>
      <Grid item xs={12}>
        <Button
          style={{ marginTop: "9vh" }}
          type="submit"
          fullWidth
          variant="contained"
          // className="btnForm activatedButton Vazirmatn"
          disabled={openOrder?.insufficientInventory || count < 0}
          className={`${
            openOrder?.insufficientInventory || count <= 0
              ? "btnForm deactivatedButton Vazirmatn "
              : "btnForm activatedButton Vazirmatn "
          }`}
          onClick={handleOrederRegister}
        >
          <b>
            <img src="/images/storeBasket.png" />
            &nbsp;ثبت درخواست کالا
          </b>
        </Button>
      </Grid>
      {openCancelModal && (
        <CancelModal
          setOpenCancelModal={setOpenCancelModal}
          openCancelModal={openCancelModal}
          serviceName={DeleteCartItem}
          requestModel={{ inventoryId, orderId }}
          response={StoreResponse}
          handleCancel={handleCancel}
        />
      )}
      <ModalCmp
        openModel={openValidationModel}
        validationMessages={validationMessages}
        firstPartOfTitle=" درخواست سفارش به دلایل زیر"
        boldTitle="پذیرفته"
        secondPartOfTitle="نشد:"
      />
    </Grid>
  );
}
